import { render, staticRenderFns } from "./gameRiskData.vue?vue&type=template&id=2860c8c6&scoped=true"
import script from "./gameRiskData.vue?vue&type=script&lang=js"
export * from "./gameRiskData.vue?vue&type=script&lang=js"
import style0 from "./gameRiskData.vue?vue&type=style&index=0&id=2860c8c6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2860c8c6",
  null
  
)

export default component.exports